define(
({
  "select_shipping_method": "Versandmethode auswählen"
})
);
